import React from "react";

const HeaderProject = () => {
  return (
    <div>
      <nav className="bg-bgDark py-4">
        <h1 className="text-3xl font-bold text-center text-white">
          Top Projects
        </h1>
      </nav>
    </div>
  );
};

export default HeaderProject;
